import './_Menu.scss';
import { Menu, Icon, Badge } from '@arkas/coreui';
import { applicationState } from '@/states/applicationState';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { MenuItemDto } from '@emutabakat-types/app';
import mutabakatModel from '@/states/mutabakatModel';
import { NavLink } from 'react-router-dom';
import React from 'react';
import { UserDto } from '@emutabakat-types/anaveri';

const { SubMenu } = Menu;

interface AppMenuProps {
  isSmallScreen: boolean;
  mode:
    | 'vertical'
    | 'vertical-left'
    | 'vertical-right'
    | 'horizontal'
    | 'inline'
    | undefined;
  toggleSider: Function;
  collapsed: boolean;
  theme: 'light' | 'dark' | undefined;
  menuItems: MenuItemDto[];
  searching: boolean;
  currentUser: UserDto;
  onaydakiMusteriSaticiAdet: number;
  onaydakiBaBsAdet: number;
}

interface AppMenuStates {}

/**
 * AppMenu Component
 */
class AppMenu extends React.Component<AppMenuProps, AppMenuStates> {
  createSubMenu(item: MenuItemDto, key: string) {
    const {
      onaydakiMusteriSaticiAdet,
      onaydakiBaBsAdet,
      searching,
      collapsed
    } = this.props;
    const countList = [
      onaydakiMusteriSaticiAdet.toString(),
      onaydakiBaBsAdet.toString()
    ];
    return searching && !collapsed ? (
      <Menu.ItemGroup
        key={key}
        title={
          <span>
            <span>{item.title}</span>
          </span>
        }
      >
        {item.items &&
          item.items.map(
            (subItem: MenuItemDto, i: number) =>
              subItem.items && subItem.items.length > 0
                ? this.createSubMenu(subItem, `${key}-sub-${i}`)
                : this.createMenuItem(subItem, `${key}-${i}`, countList[i])
          )}
      </Menu.ItemGroup>
    ) : (
      <SubMenu
        className="submenu"
        key={key}
        title={
          <span>
            {item.icon && <Icon type={item.icon} />}
            <span
              style={{
                marginLeft: item.icon ? 0 : 26,
                opacity: collapsed ? 0 : 1
              }}
            >
              {item.title}
            </span>
          </span>
        }
      >
        {item.items &&
          item.items.map(
            (subItem: MenuItemDto, i: number) =>
              subItem.items && subItem.items.length > 0
                ? this.createSubMenu(subItem, `${key}-sub-${i}`)
                : this.createMenuItem(subItem, `${key}-${i}`, countList[i])
          )}
      </SubMenu>
    );
  }

  createMenuItem(item: MenuItemDto, key: string, count: string) {
    return (
      <Menu.Item key={key} title={item.title}>
        <NavLink to={item.url!} onClick={this.collapseMobileSider}>
          {item.icon && <Icon type={item.icon} />}
          <span
            style={{
              marginLeft: item.icon ? 0 : 26
            }}
          >
            {item.title}
          </span>
          <Badge
            style={{ marginLeft: 10, backgroundColor: '#1890ff' }}
            count={count}
            overflowCount={99}
            offset={[0, -4]}
            showZero={false}
          />
        </NavLink>
      </Menu.Item>
    );
  }

  collapseMobileSider = () => {
    mutabakatModel.setRandom(Math.random());
    const { isSmallScreen, mode, toggleSider } = this.props;
    if (isSmallScreen && mode === 'inline') {
      toggleSider(true);
    }
  };

  render() {
    const {
      onaydakiMusteriSaticiAdet,
      onaydakiBaBsAdet,
      mode,
      collapsed,
      theme,
      menuItems,
      searching
    } = this.props;
    const countList = [
      onaydakiMusteriSaticiAdet.toString(),
      onaydakiBaBsAdet.toString()
    ];
    return (
      <Menu
        className={classnames(
          'app-menu',
          mode === 'horizontal' ? 'top-menu' : collapsed && 'collapsed',
          searching && !collapsed && 'searching'
        )}
        mode={mode}
        theme={theme}
        inlineIndent={8}
      >
        {menuItems.map(
          (item, i) =>
            item.items && item.items.length > 0
              ? this.createSubMenu(item, `sub-${i}`)
              : this.createMenuItem(item, i.toString(), countList[i])
        )}
      </Menu>
    );
  }
}

const mapStateToProps = (state: applicationState) => {
  return {
    isSmallScreen: state.appModel.isSmallScreen,
    currentUser: state.kullaniciModel.currentUser,
    onaydakiMusteriSaticiAdet: state.mutabakatModel.onaydakiMusteriSaticiAdet,
    onaydakiBaBsAdet: state.mutabakatModel.onaydakiBaBsAdet
  };
};

export default connect(mapStateToProps)(AppMenu);
